var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    _vm.$style.previewField ]},[_c('div',{class:_vm.$style.name,style:({ width: ((_vm.ratio[0] * 100) + "%") })},[_vm._v(" "+_vm._s(_vm.name)+" ")]),_c('div',{class:_vm.$style.value,style:({ width: ((_vm.ratio[1] * 100) + "%") })},[_vm._v(" "+_vm._s(_vm.value)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }